const formatId = (id: string): string => {
  const zero: string = Array(6 - id.length)
    .fill(0)
    .join('')
  return String(zero + id)
}

export { formatId }
